/* eslint quote-props: ["error", "as-needed", { "keywords": true, "unnecessary": false }] */

export default [
  {
    'alpha2': 'af',
    'countryCode': '93',
  },
  {
    'alpha2': 'al',
    'countryCode': '355',
  },
  {
    'alpha2': 'dz',
    'countryCode': '213',
  },
  {
    'alpha2': 'as',
    'countryCode': '1',
  },
  {
    'alpha2': 'ad',
    'countryCode': '376',
  },
  {
    'alpha2': 'ao',
    'countryCode': '244',
  },
  {
    'alpha2': 'ai',
    'countryCode': '1',
  },
  {
    'alpha2': 'ag',
    'countryCode': '1',
  },
  {
    'alpha2': 'ar',
    'countryCode': '54',
  },
  {
    'alpha2': 'am',
    'countryCode': '374',
  },
  {
    'alpha2': 'aw',
    'countryCode': '297',
  },
  {
    'alpha2': 'ac',
    'countryCode': '247',
  },
  {
    'alpha2': 'au',
    'countryCode': '61',
  },
  {
    'alpha2': 'at',
    'countryCode': '43',
  },
  {
    'alpha2': 'az',
    'countryCode': '994',
  },
  {
    'alpha2': 'bs',
    'countryCode': '1',
  },
  {
    'alpha2': 'bh',
    'countryCode': '973',
  },
  {
    'alpha2': 'bd',
    'countryCode': '880',
  },
  {
    'alpha2': 'bb',
    'countryCode': '1',
  },
  {
    'alpha2': 'by',
    'countryCode': '375',
  },
  {
    'alpha2': 'be',
    'countryCode': '32',
  },
  {
    'alpha2': 'bz',
    'countryCode': '501',
  },
  {
    'alpha2': 'bj',
    'countryCode': '229',
  },
  {
    'alpha2': 'bm',
    'countryCode': '1',
  },
  {
    'alpha2': 'bt',
    'countryCode': '975',
  },
  {
    'alpha2': 'bo',
    'countryCode': '591',
  },
  {
    'alpha2': 'ba',
    'countryCode': '387',
  },
  {
    'alpha2': 'bw',
    'countryCode': '267',
  },
  {
    'alpha2': 'br',
    'countryCode': '55',
  },
  {
    'alpha2': 'io',
    'countryCode': '246',
  },
  {
    'alpha2': 'vg',
    'countryCode': '1',
  },
  {
    'alpha2': 'bn',
    'countryCode': '673',
  },
  {
    'alpha2': 'bg',
    'countryCode': '359',
  },
  {
    'alpha2': 'bf',
    'countryCode': '226',
  },
  {
    'alpha2': 'bi',
    'countryCode': '257',
  },
  {
    'alpha2': 'kh',
    'countryCode': '855',
  },
  {
    'alpha2': 'cm',
    'countryCode': '237',
  },
  {
    'alpha2': 'ca',
    'countryCode': '1',
  },
  {
    'alpha2': 'cv',
    'countryCode': '238',
  },
  {
    'alpha2': 'bq',
    'countryCode': '599',
  },
  {
    'alpha2': 'ky',
    'countryCode': '1',
  },
  {
    'alpha2': 'cf',
    'countryCode': '236',
  },
  {
    'alpha2': 'td',
    'countryCode': '235',
  },
  {
    'alpha2': 'cl',
    'countryCode': '56',
  },
  {
    'alpha2': 'cn',
    'countryCode': '86',
  },
  {
    'alpha2': 'cx',
    'countryCode': '61',
  },
  {
    'alpha2': 'cc',
    'countryCode': '61',
  },
  {
    'alpha2': 'co',
    'countryCode': '57',
  },
  {
    'alpha2': 'km',
    'countryCode': '269',
  },
  {
    'alpha2': 'cd',
    'countryCode': '243',
  },
  {
    'alpha2': 'cg',
    'countryCode': '242',
  },
  {
    'alpha2': 'ck',
    'countryCode': '682',
  },
  {
    'alpha2': 'cr',
    'countryCode': '506',
  },
  {
    'alpha2': 'ci',
    'countryCode': '225',
  },
  {
    'alpha2': 'hr',
    'countryCode': '385',
  },
  {
    'alpha2': 'cu',
    'countryCode': '53',
  },
  {
    'alpha2': 'cw',
    'countryCode': '599',
  },
  {
    'alpha2': 'cy',
    'countryCode': '357',
  },
  {
    'alpha2': 'cz',
    'countryCode': '420',
  },
  {
    'alpha2': 'dk',
    'countryCode': '45',
  },
  {
    'alpha2': 'dj',
    'countryCode': '253',
  },
  {
    'alpha2': 'dm',
    'countryCode': '1',
  },
  {
    'alpha2': 'do',
    'countryCode': '1',
  },
  {
    'alpha2': 'ec',
    'countryCode': '593',
  },
  {
    'alpha2': 'eg',
    'countryCode': '20',
  },
  {
    'alpha2': 'sv',
    'countryCode': '503',
  },
  {
    'alpha2': 'gq',
    'countryCode': '240',
  },
  {
    'alpha2': 'er',
    'countryCode': '291',
  },
  {
    'alpha2': 'ee',
    'countryCode': '372',
  },
  {
    'alpha2': 'sz',
    'countryCode': '268',
  },
  {
    'alpha2': 'et',
    'countryCode': '251',
  },
  {
    'alpha2': 'fk',
    'countryCode': '500',
  },
  {
    'alpha2': 'fo',
    'countryCode': '298',
  },
  {
    'alpha2': 'fj',
    'countryCode': '679',
  },
  {
    'alpha2': 'fi',
    'countryCode': '358',
  },
  {
    'alpha2': 'fr',
    'countryCode': '33',
  },
  {
    'alpha2': 'gf',
    'countryCode': '594',
  },
  {
    'alpha2': 'pf',
    'countryCode': '689',
  },
  {
    'alpha2': 'ga',
    'countryCode': '241',
  },
  {
    'alpha2': 'gm',
    'countryCode': '220',
  },
  {
    'alpha2': 'ge',
    'countryCode': '995',
  },
  {
    'alpha2': 'de',
    'countryCode': '49',
  },
  {
    'alpha2': 'gh',
    'countryCode': '233',
  },
  {
    'alpha2': 'gi',
    'countryCode': '350',
  },
  {
    'alpha2': 'gr',
    'countryCode': '30',
  },
  {
    'alpha2': 'gl',
    'countryCode': '299',
  },
  {
    'alpha2': 'gd',
    'countryCode': '1',
  },
  {
    'alpha2': 'gp',
    'countryCode': '590',
  },
  {
    'alpha2': 'gu',
    'countryCode': '1',
  },
  {
    'alpha2': 'gt',
    'countryCode': '502',
  },
  {
    'alpha2': 'gg',
    'countryCode': '44',
  },
  {
    'alpha2': 'gn',
    'countryCode': '224',
  },
  {
    'alpha2': 'gw',
    'countryCode': '245',
  },
  {
    'alpha2': 'gy',
    'countryCode': '592',
  },
  {
    'alpha2': 'ht',
    'countryCode': '509',
  },
  {
    'alpha2': 'hn',
    'countryCode': '504',
  },
  {
    'alpha2': 'hk',
    'countryCode': '852',
  },
  {
    'alpha2': 'hu',
    'countryCode': '36',
  },
  {
    'alpha2': 'is',
    'countryCode': '354',
  },
  {
    'alpha2': 'in',
    'countryCode': '91',
  },
  {
    'alpha2': 'id',
    'countryCode': '62',
  },
  {
    'alpha2': 'ir',
    'countryCode': '98',
  },
  {
    'alpha2': 'iq',
    'countryCode': '964',
  },
  {
    'alpha2': 'ie',
    'countryCode': '353',
  },
  {
    'alpha2': 'im',
    'countryCode': '44',
  },
  {
    'alpha2': 'il',
    'countryCode': '972',
  },
  {
    'alpha2': 'it',
    'countryCode': '39',
  },
  {
    'alpha2': 'jm',
    'countryCode': '1',
  },
  {
    'alpha2': 'jp',
    'countryCode': '81',
  },
  {
    'alpha2': 'je',
    'countryCode': '44',
  },
  {
    'alpha2': 'jo',
    'countryCode': '962',
  },
  {
    'alpha2': 'kz',
    'countryCode': '7',
  },
  {
    'alpha2': 'ke',
    'countryCode': '254',
  },
  {
    'alpha2': 'ki',
    'countryCode': '686',
  },
  {
    'alpha2': 'xk',
    'countryCode': '383',
  },
  {
    'alpha2': 'kw',
    'countryCode': '965',
  },
  {
    'alpha2': 'kg',
    'countryCode': '996',
  },
  {
    'alpha2': 'la',
    'countryCode': '856',
  },
  {
    'alpha2': 'lv',
    'countryCode': '371',
  },
  {
    'alpha2': 'lb',
    'countryCode': '961',
  },
  {
    'alpha2': 'ls',
    'countryCode': '266',
  },
  {
    'alpha2': 'lr',
    'countryCode': '231',
  },
  {
    'alpha2': 'ly',
    'countryCode': '218',
  },
  {
    'alpha2': 'li',
    'countryCode': '423',
  },
  {
    'alpha2': 'lt',
    'countryCode': '370',
  },
  {
    'alpha2': 'lu',
    'countryCode': '352',
  },
  {
    'alpha2': 'mo',
    'countryCode': '853',
  },
  {
    'alpha2': 'mk',
    'countryCode': '389',
  },
  {
    'alpha2': 'mg',
    'countryCode': '261',
  },
  {
    'alpha2': 'mw',
    'countryCode': '265',
  },
  {
    'alpha2': 'my',
    'countryCode': '60',
  },
  {
    'alpha2': 'mv',
    'countryCode': '960',
  },
  {
    'alpha2': 'ml',
    'countryCode': '223',
  },
  {
    'alpha2': 'mt',
    'countryCode': '356',
  },
  {
    'alpha2': 'mh',
    'countryCode': '692',
  },
  {
    'alpha2': 'mq',
    'countryCode': '596',
  },
  {
    'alpha2': 'mr',
    'countryCode': '222',
  },
  {
    'alpha2': 'mu',
    'countryCode': '230',
  },
  {
    'alpha2': 'yt',
    'countryCode': '262',
  },
  {
    'alpha2': 'mx',
    'countryCode': '52',
  },
  {
    'alpha2': 'fm',
    'countryCode': '691',
  },
  {
    'alpha2': 'md',
    'countryCode': '373',
  },
  {
    'alpha2': 'mc',
    'countryCode': '377',
  },
  {
    'alpha2': 'mn',
    'countryCode': '976',
  },
  {
    'alpha2': 'me',
    'countryCode': '382',
  },
  {
    'alpha2': 'ms',
    'countryCode': '1',
  },
  {
    'alpha2': 'ma',
    'countryCode': '212',
  },
  {
    'alpha2': 'mz',
    'countryCode': '258',
  },
  {
    'alpha2': 'mm',
    'countryCode': '95',
  },
  {
    'alpha2': 'na',
    'countryCode': '264',
  },
  {
    'alpha2': 'nr',
    'countryCode': '674',
  },
  {
    'alpha2': 'np',
    'countryCode': '977',
  },
  {
    'alpha2': 'nl',
    'countryCode': '31',
  },
  {
    'alpha2': 'nc',
    'countryCode': '687',
  },
  {
    'alpha2': 'nz',
    'countryCode': '64',
  },
  {
    'alpha2': 'ni',
    'countryCode': '505',
  },
  {
    'alpha2': 'ne',
    'countryCode': '227',
  },
  {
    'alpha2': 'ng',
    'countryCode': '234',
  },
  {
    'alpha2': 'nu',
    'countryCode': '683',
  },
  {
    'alpha2': 'nf',
    'countryCode': '672',
  },
  {
    'alpha2': 'kp',
    'countryCode': '850',
  },
  {
    'alpha2': 'mp',
    'countryCode': '1',
  },
  {
    'alpha2': 'no',
    'countryCode': '47',
  },
  {
    'alpha2': 'om',
    'countryCode': '968',
  },
  {
    'alpha2': 'pk',
    'countryCode': '92',
  },
  {
    'alpha2': 'pw',
    'countryCode': '680',
  },
  {
    'alpha2': 'ps',
    'countryCode': '970',
  },
  {
    'alpha2': 'pa',
    'countryCode': '507',
  },
  {
    'alpha2': 'pg',
    'countryCode': '675',
  },
  {
    'alpha2': 'py',
    'countryCode': '595',
  },
  {
    'alpha2': 'pe',
    'countryCode': '51',
  },
  {
    'alpha2': 'ph',
    'countryCode': '63',
  },
  {
    'alpha2': 'pl',
    'countryCode': '48',
  },
  {
    'alpha2': 'pt',
    'countryCode': '351',
  },
  {
    'alpha2': 'pr',
    'countryCode': '1',
  },
  {
    'alpha2': 'qa',
    'countryCode': '974',
  },
  {
    'alpha2': 're',
    'countryCode': '262',
  },
  {
    'alpha2': 'ro',
    'countryCode': '40',
  },
  {
    'alpha2': 'ru',
    'countryCode': '7',
  },
  {
    'alpha2': 'rw',
    'countryCode': '250',
  },
  {
    'alpha2': 'bl',
    'countryCode': '590',
  },
  {
    'alpha2': 'sh',
    'countryCode': '290',
  },
  {
    'alpha2': 'kn',
    'countryCode': '1',
  },
  {
    'alpha2': 'lc',
    'countryCode': '1',
  },
  {
    'alpha2': 'mf',
    'countryCode': '590',
  },
  {
    'alpha2': 'pm',
    'countryCode': '508',
  },
  {
    'alpha2': 'vc',
    'countryCode': '1',
  },
  {
    'alpha2': 'ws',
    'countryCode': '685',
  },
  {
    'alpha2': 'sm',
    'countryCode': '378',
  },
  {
    'alpha2': 'st',
    'countryCode': '239',
  },
  {
    'alpha2': 'sa',
    'countryCode': '966',
  },
  {
    'alpha2': 'sn',
    'countryCode': '221',
  },
  {
    'alpha2': 'rs',
    'countryCode': '381',
  },
  {
    'alpha2': 'sc',
    'countryCode': '248',
  },
  {
    'alpha2': 'sl',
    'countryCode': '232',
  },
  {
    'alpha2': 'sg',
    'countryCode': '65',
  },
  {
    'alpha2': 'sx',
    'countryCode': '1',
  },
  {
    'alpha2': 'sk',
    'countryCode': '421',
  },
  {
    'alpha2': 'si',
    'countryCode': '386',
  },
  {
    'alpha2': 'sb',
    'countryCode': '677',
  },
  {
    'alpha2': 'so',
    'countryCode': '252',
  },
  {
    'alpha2': 'za',
    'countryCode': '27',
  },
  {
    'alpha2': 'kr',
    'countryCode': '82',
  },
  {
    'alpha2': 'ss',
    'countryCode': '211',
  },
  {
    'alpha2': 'es',
    'countryCode': '34',
  },
  {
    'alpha2': 'lk',
    'countryCode': '94',
  },
  {
    'alpha2': 'sd',
    'countryCode': '249',
  },
  {
    'alpha2': 'sr',
    'countryCode': '597',
  },
  {
    'alpha2': 'sj',
    'countryCode': '47',
  },
  {
    'alpha2': 'se',
    'countryCode': '46',
  },
  {
    'alpha2': 'ch',
    'countryCode': '41',
  },
  {
    'alpha2': 'sy',
    'countryCode': '963',
  },
  {
    'alpha2': 'tw',
    'countryCode': '886',
  },
  {
    'alpha2': 'tj',
    'countryCode': '992',
  },
  {
    'alpha2': 'tz',
    'countryCode': '255',
  },
  {
    'alpha2': 'th',
    'countryCode': '66',
  },
  {
    'alpha2': 'tl',
    'countryCode': '670',
  },
  {
    'alpha2': 'tg',
    'countryCode': '228',
  },
  {
    'alpha2': 'tk',
    'countryCode': '690',
  },
  {
    'alpha2': 'to',
    'countryCode': '676',
  },
  {
    'alpha2': 'tt',
    'countryCode': '1',
  },
  {
    'alpha2': 'tn',
    'countryCode': '216',
  },
  {
    'alpha2': 'tr',
    'countryCode': '90',
  },
  {
    'alpha2': 'tm',
    'countryCode': '993',
  },
  {
    'alpha2': 'tc',
    'countryCode': '1',
  },
  {
    'alpha2': 'tv',
    'countryCode': '688',
  },
  {
    'alpha2': 'vi',
    'countryCode': '1',
  },
  {
    'alpha2': 'ug',
    'countryCode': '256',
  },
  {
    'alpha2': 'ua',
    'countryCode': '380',
  },
  {
    'alpha2': 'ae',
    'countryCode': '971',
  },
  {
    'alpha2': 'gb',
    'countryCode': '44',
  },
  {
    'alpha2': 'us',
    'countryCode': '1',
  },
  {
    'alpha2': 'uy',
    'countryCode': '598',
  },
  {
    'alpha2': 'uz',
    'countryCode': '998',
  },
  {
    'alpha2': 'vu',
    'countryCode': '678',
  },
  {
    'alpha2': 'va',
    'countryCode': '39',
  },
  {
    'alpha2': 've',
    'countryCode': '58',
  },
  {
    'alpha2': 'vn',
    'countryCode': '84',
  },
  {
    'alpha2': 'wf',
    'countryCode': '681',
  },
  {
    'alpha2': 'eh',
    'countryCode': '212',
  },
  {
    'alpha2': 'ye',
    'countryCode': '967',
  },
  {
    'alpha2': 'zm',
    'countryCode': '260',
  },
  {
    'alpha2': 'zw',
    'countryCode': '263',
  },
  {
    'alpha2': 'ax',
    'countryCode': '358',
  },
];
